import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import Clock from "../../icons/clock.svg";
import Fire from "../../icons/fire.svg";
import { DEPRECATED_Typography } from "../DEPRECATED_Typography";
import { Icon } from "../Icon";
import styles from "./TimeLimitedBadge.module.scss";
export const TimeLimitedBadge = ({ color, label, isDisabled, className, isMoreThanOneDay, }) => {
    if (!label || isDisabled)
        return null;
    const classes = classNames(styles.timeLimitedBadge, className, {
        [styles.lastDay]: !isMoreThanOneDay,
    });
    const iconClasses = classNames(styles.iconWhite, {
        [styles.iconBlack]: isMoreThanOneDay && color === "grey-3",
    });
    return (_jsxs("div", { className: classes, "data-testid": "timeLimitedBadge", children: [_jsx(Icon, { component: isMoreThanOneDay ? Clock : Fire, width: "18px", height: "18px", className: iconClasses }), _jsx(DEPRECATED_Typography, { type: "table-content", color: isMoreThanOneDay ? color : "white", className: styles.label, children: label })] }));
};
//# sourceMappingURL=TimeLimitedBadge.js.map